import { goUrl } from "@/lib/content";

// Renders a responsive deals comparison table (light/orange theme).
export default function DealsTable({ columns, rows, fields }) {
  return (
    <div
      data-testid="deals-table"
      className="w-full overflow-x-auto rounded-2xl border border-slate-200 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
    >
      <table className="w-full min-w-[640px] border-collapse">
        <thead>
          <tr className="bg-[#2C3E50] text-white">
            {columns.map((c, i) => (
              <th
                key={i}
                className="text-left text-xs sm:text-sm font-semibold uppercase tracking-wider py-4 px-5"
              >
                {c}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((d) => (
            <tr
              key={d.id}
              data-testid={`deal-row-${d.id}`}
              className="border-t border-slate-100 hover:bg-slate-50/70 transition-colors"
            >
              {fields.map((f, i) => (
                <td
                  key={i}
                  className={`py-4 px-5 text-sm ${
                    f === "price" ? "font-bold text-[#2C3E50]" : "text-slate-700"
                  } ${f === "availability" ? "text-emerald-600 whitespace-nowrap" : ""}`}
                >
                  {f === "event" ? (
                    <span className="font-semibold text-slate-900">{d[f]}</span>
                  ) : (
                    d[f]
                  )}
                </td>
              ))}
              <td className="py-4 px-5 text-right">
                <a
                  href={goUrl(d.provider_slug)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`buy-now-${d.id}`}
                  className="inline-flex items-center bg-[#FF6B35] hover:bg-[#E55A2A] text-white text-sm font-semibold rounded-full px-5 py-2.5 transition-all hover:-translate-y-0.5 shadow-sm"
                >
                  {["tix", "cheaptickets", "booking"].includes(d.provider_slug) ? "Boek Nu" : "Koop Nu"}
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
